import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import logo from "../../assets/img/logo.png";
import "./index.scss";

const Navbarmenu = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };

  let boxClass = ["main-menu menu-right menuq1"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  const [isMenuSubMenu, setMenuSubMenu] = useState(false);

  const toggleSubmenu = () => {
    setMenuSubMenu(isMenuSubMenu === false ? true : false);
  };

  let boxClassSubMenu = ["sub__menus"];
  if (isMenuSubMenu) {
    boxClassSubMenu.push("sub__menus__Active");
  } else {
    boxClassSubMenu.push("");
  }

  return (
    <div className="nav">
      <header className="header__middle">
        <div className="nav__container">
          {/* Add Logo  */}
          <div className="header__middle__logo">
            <NavLink
              exact="true"
              className={({ isActive }) => (isActive ? "active-style" : "none")}
              to="/"
            >
              <img src={logo} alt="logo" />
            </NavLink>
          </div>

          <div className="header__middle__menus">
            <nav className="main-nav ">
              {/* Responsive Menu Button */}
              {isResponsiveclose === true ? (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    {" "}
                    <FiXCircle />{" "}
                  </span>
                </>
              ) : (
                <>
                  <span
                    className="menubar__button"
                    style={{ display: "none" }}
                    onClick={toggleClass}
                  >
                    {" "}
                    <FiAlignRight />{" "}
                  </span>
                </>
              )}

              <ul className={boxClass.join(" ")}>
                <li className="menu-item">
                  <NavLink
                    exact="true"
                    className={({ isActive }) =>
                      isActive ? "active-style" : "none"
                    }
                    onClick={toggleClass}
                    to={`/`}
                  >
                    {" "}
                    首页{" "}
                  </NavLink>
                </li>
                {/* <li className="menu-item ">
                <NavLink
                  onClick={toggleClass}
                  className={({ isActive }) =>
                    isActive ? "active-style" : "none"
                  }
                  to={`/About`}
                >
                  {" "}
                  产品分类{" "}
                </NavLink>{" "}
              </li> */}
                <li
                  onClick={toggleSubmenu}
                  className="menu-item sub__menus__arrows"
                >
                  {" "}
                  <Link to="#">
                    {" "}
                    关于我们 <FiChevronDown />{" "}
                  </Link>
                  <ul className={boxClassSubMenu.join(" ")}>
                    <li>
                      {" "}
                      <NavLink
                        onClick={toggleClass}
                        className={({ isActive }) =>
                          isActive ? "active-style" : "none"
                        }
                        to={`/intro`}
                      >
                        {" "}
                        公司简介{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        onClick={toggleClass}
                        className={({ isActive }) =>
                          isActive ? "active-style" : "none"
                        }
                        to={`/Offline`}
                      >
                        {" "}
                        企业代理{" "}
                      </NavLink>{" "}
                    </li>
                  </ul>
                </li>
                <li
                  onClick={toggleSubmenu}
                  className="menu-item sub__menus__arrows"
                >
                  {" "}
                  <Link to="#">
                    {" "}
                    轴承介绍 <FiChevronDown />{" "}
                  </Link>
                  <ul className={boxClassSubMenu.join(" ")}>
                    <li>
                      {" "}
                      <NavLink
                        onClick={toggleClass}
                        className={({ isActive }) =>
                          isActive ? "active-style" : "none"
                        }
                        to={`/Online`}
                      >
                        {" "}
                        IKO{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        onClick={toggleClass}
                        className={({ isActive }) =>
                          isActive ? "active-style" : "none"
                        }
                        to={`/Offline`}
                      >
                        {" "}
                        UBC{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        onClick={toggleClass}
                        className={({ isActive }) =>
                          isActive ? "active-style" : "none"
                        }
                        to={`/Offline`}
                      >
                        {" "}
                        NNC{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        onClick={toggleClass}
                        className={({ isActive }) =>
                          isActive ? "active-style" : "none"
                        }
                        to={`/Offline`}
                      >
                        {" "}
                        YTP{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        onClick={toggleClass}
                        className={({ isActive }) =>
                          isActive ? "active-style" : "none"
                        }
                        to={`/Offline`}
                      >
                        {" "}
                        KML{" "}
                      </NavLink>{" "}
                    </li>
                  </ul>
                </li>
                <li
                  onClick={toggleSubmenu}
                  className="menu-item sub__menus__arrows"
                >
                  {" "}
                  <Link to="#">
                    {" "}
                    导轨介绍 <FiChevronDown />{" "}
                  </Link>
                  <ul className={boxClassSubMenu.join(" ")}>
                    <li>
                      {" "}
                      <NavLink
                        onClick={toggleClass}
                        className={({ isActive }) =>
                          isActive ? "active-style" : "none"
                        }
                        to={`/Online`}
                      >
                        {" "}
                        AXPB{" "}
                      </NavLink>{" "}
                    </li>
                    <li>
                      <NavLink
                        onClick={toggleClass}
                        className={({ isActive }) =>
                          isActive ? "active-style" : "none"
                        }
                        to={`/Offline`}
                      >
                        {" "}
                        ULS{" "}
                      </NavLink>{" "}
                    </li>
                  </ul>
                </li>
                <li className="menu-item ">
                  <NavLink
                    onClick={toggleClass}
                    className={({ isActive }) =>
                      isActive ? "active-style" : "none"
                    }
                    to={`/Contact`}
                  >
                    {" "}
                    联系我们{" "}
                  </NavLink>{" "}
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbarmenu;
